const configType = {
  onlyText: '1',
  draw: '2',
  atached: '3',
  desing: '4'
};

const ambits = {
  managedment: 'unidad',
  profile: 'perfil'
};

const configutationsIds = {
  type: 'io.febos.firmafebos.tipo',
  template: 'io.febos.firmafebos.plantilla',
  background: 'io.febos.firmafebos.background',
  emulation: 'io.febos.firmafebos.emulacion',
  respresentation: 'io.febos.firmafebos.representacion',
};
const certStatus = {
  CREATE: 1,
  ACTIVE: 2,
  EXPIRED: 3,
};
export {
  configType, configutationsIds, certStatus, ambits
};
